// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navbar {
    border-bottom: solid #824bb0 2px !important;
    color: black !important;
    padding: 0% !important;
    /* height: 8%; */
    height: 60px;
    width: 100%;
}

.navbar-brand {
    color: var(--main-hg-color) !important;
    font-weight: bold !important;
    margin-left: 50px;
}

.container-fluid {
    text-align: center;
}

.navbar-nav {
    margin-left: 50px !important;
    /* height: 100%; */
    height: 50px;
}

.nav-link:not([disabled]) {
    color: gray !important;
    height: 100% ;
    padding-top: 18px !important;
    width: 200px;
    border-left:3px solid var(--main-very-light-hg-color) !important;
}

.nav-link.active {
    color: white !important;
}


.nav-link:hover {
    background-color: var(--main-light-hg-color);
    color: white !important;
    font-weight: bold !important;
}

@media (max-width: 768px) {
    .navbar-brand {
        margin: 5px !important;
        width: 5%;
    }
    
    .navbar-nav {
        height: 54px;
        font-weight: bold;
    }
    /*.nav-link:not([disabled]) {*/
    /*    width: 50px;*/
    /*}*/
    .nav-link {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

}
`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":";AACA;IACI,2CAA2C;IAC3C,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,gEAAgE;AACpE;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,4CAA4C;IAC5C,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA,8BAA8B;IAC9B,mBAAmB;IACnB,IAAI;IACJ;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;AAEJ","sourcesContent":["\n.navbar {\n    border-bottom: solid #824bb0 2px !important;\n    color: black !important;\n    padding: 0% !important;\n    /* height: 8%; */\n    height: 60px;\n    width: 100%;\n}\n\n.navbar-brand {\n    color: var(--main-hg-color) !important;\n    font-weight: bold !important;\n    margin-left: 50px;\n}\n\n.container-fluid {\n    text-align: center;\n}\n\n.navbar-nav {\n    margin-left: 50px !important;\n    /* height: 100%; */\n    height: 50px;\n}\n\n.nav-link:not([disabled]) {\n    color: gray !important;\n    height: 100% ;\n    padding-top: 18px !important;\n    width: 200px;\n    border-left:3px solid var(--main-very-light-hg-color) !important;\n}\n\n.nav-link.active {\n    color: white !important;\n}\n\n\n.nav-link:hover {\n    background-color: var(--main-light-hg-color);\n    color: white !important;\n    font-weight: bold !important;\n}\n\n@media (max-width: 768px) {\n    .navbar-brand {\n        margin: 5px !important;\n        width: 5%;\n    }\n    \n    .navbar-nav {\n        height: 54px;\n        font-weight: bold;\n    }\n    /*.nav-link:not([disabled]) {*/\n    /*    width: 50px;*/\n    /*}*/\n    .nav-link {\n        padding-right: 0 !important;\n        padding-left: 0 !important;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
